import { CustomButton } from "@/components/ui/Buttons";
import { handleDownload } from "@/utils/handleDownload";
import { CheckCircle2 } from "lucide-react";
import FileIcon from "@/assets/icons/FileIcon.svg";
import DownloadIcon from "@/assets/icons/DownloadIcon.svg";
import { TProductShipping } from "@/redux/feature/orderManagement/productShipping/productShippingTypes";
// import { formatFileSize } from "@/utils/formateSize";
import { NotificationCard } from "./NotificationCard";
import CheckLightGreenFill from '@/assets/icons/CheckLightGreenFill.svg'

const ShippedProductView = ({
  productShippingData,
}: {
  productShippingData: TProductShipping;
}) => {
  return (
    <div className="w-full mx-auto py-4 px-4">
      <NotificationCard
        title="Product in Your Hands!"
        icon={<CheckLightGreenFill />}
        description="The product is with you!  We're excited to see the content you create!"
      />
     
    </div>
  );
};

export default ShippedProductView;
